import { Box, Container } from '@mui/material';
import React from 'react';
import Auth from '../components/Auth';
import { useAuth } from '../store/auth.store';
import Area from '../components/Area';

const ChooseAreaPage = () => {
    const {user} = useAuth()
    return (
        <Container 
            sx={{ 
                height: '100vh', 
                display: 'flex', 
                flexDirection: 'column', 
                justifyContent: 'space-between', 
                py: '50px', 
                px: '20px' 
            }}
        >
            <Auth.AuthHeader />
            <Box sx={{ flexGrow: 1, paddingTop:'100px' }}> 
                <Area.Choose/>
            </Box>
        </Container>
    );
};

export default ChooseAreaPage;